<template>
    <div class='winter-night-tickets'>
        <h6 class="text-center">{{'lucky_numbers' | lang}}</h6>
        <div class="lucky-symbols w-100 d-flex align-items-center justify-content-center">
            <div v-for="(symbol, itemIndex) in ticket.scenario.lucky_symbols" :key="itemIndex" class="symbol  d-flex align-items-center justify-content-center"> 
                <img class="img-fluid" :src="`/fg/v2/games/winter_night/img/history/${symbol}_${yourSymbolsFlat.includes(symbol) ? 'red' : 'blue'}.png`">
            </div>
        </div>
        <h6 class="text-center pt-3">{{'your_numbers' | lang}}</h6>
        <div class="your-symbols w-100">
            <div v-for="(row, rowIndex) in groupedScenarioYourSymbols" :key="rowIndex" class='w-100 d-flex align-items-center justify-content-center'> 
                <div v-for="(item, itemIndex) in row" :key="itemIndex" :class="`symbol d-flex align-items-center justify-content-center flex-column ${item.win || item.symbol === 'star' ? 'lucky' : 'unlucky'}`"> 
                    <img v-if="item.symbol === 'star'" class="lucky img-fluid" src="/fg/v2/games/winter_night/img/history/star.png">
                    <img v-else class="img-fluid" :src="`/fg/v2/games/winter_night/img/history/${item.symbol}_${item.win ? 'red' : 'blue'}.png`">
                    <span v-if="item.amount" class="text-center amount">{{item.amount | currency}}</span>
                </div>
            </div>
        </div>
        <div :class="{'bonus text-center':true, 'lucky':ticket.scenario.bonus.value > 0}" v-if="ticket.scenario.bonus">
            <h6 class="pt-3">{{'bonus_winning' | lang}}</h6>
            <span>{{ticket.scenario.bonus.value | currency}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ticket', 'gameName'],
        data() { 
            return {
                yourSymbolsFlat:[]
            } 
        },
        computed: {
            groupedScenarioYourSymbols() {
                let grouped = {0:[], 1:[], 2:[], 3:[]};
                let rowIndex = 0;

                for(let i = 0; i < 20; i++) {
                    const item = this.ticket.scenario.your_symbols[i];
                    grouped[rowIndex].push(item);

                    if([4, 10, 15].includes(i)) {
                        rowIndex++;
                    }

                    this.yourSymbolsFlat.push(item.symbol);
                }

                return grouped;
            }
        }
    }
</script>

<style>
    .winter-night-tickets {
        font-family: russoone;
    }

    .winter-night-tickets .symbol {
        width: 16.66%;
        color: #ac2532;
        padding: 2px;
    }

    .winter-night-tickets .symbol img {
        width: 50% !important;
    }

    .winter-night-tickets .symbol.unlucky {
        opacity: 0.6;
        color: #226c88;
    }

    .winter-night-tickets .amount {
        background: white;
        border-radius: 500px;
        font-size: 1.5vw;
        width: 100%;
    }

    .winter-night-tickets h6 {
        font-family: russoone;
        -webkit-text-stroke-width: 0.5px;
        -webkit-text-stroke-color: black;
    }

    .winter-night-tickets .bonus span {
        color: #226c88;
        font-size: 20px;
        opacity: 0.6;
    }

    .winter-night-tickets .bonus.lucky span {
        color: #f8df46;
        opacity: 1;
    }

    @media (min-width: 992px) { 
        .winter-night-tickets .amount {
            font-size: 0.9vw;
        }
    }
</style>